module.exports = __webpack_public_path__ + "static/media/WebDeveloperRudolfResume.fc02ec59.pdf";